function isObjectLike(e){return null!=e&&"object"==typeof e}module.exports=isObjectLike;